import { Routes } from '@angular/router';
import { selectLocationGuard } from './guards/select-location.guard';
import { scheduleAppointmentGuard } from './guards/schedule-appointment.guard';
import { contactInformationGuard } from './guards/contact-information.guard';
import { resetStoreGuard } from 'src/app/guards/reset-store.guard';
import { confirmationGuard } from './guards/confirmation.guard';

export const routes: Routes = [
  {
    path: '',
    title: 'Lab Appointment',
    canActivate: [resetStoreGuard],
    loadComponent: () =>
      import('src/app/components/location-appointment/location-appointment.component').then(m => m.LocationAppointmentComponent)
  },
  {
    path: 'select-laboratory',
    title: 'Select Laboratory',
    canActivate: [selectLocationGuard],
    loadComponent: () => import('src/app/components/select-location/select-location.component').then(m => m.SelectLocationComponent)
  },
  {
    path: 'schedule-appointment',
    title: 'Schedule Appointment',
    canActivate: [scheduleAppointmentGuard],
    loadComponent: () =>
      import('./components/schedule-appointment/schedule-appointment.component').then(m => m.ScheduleAppointmentComponent)
  },
  {
    path: 'contact-information',
    title: 'Contact Information',
    canActivate: [contactInformationGuard],
    loadComponent: () =>
      import('./components/contact-information-form/contact-information-form.component').then(m => m.ContactInformationFormComponent)
  },
  {
    path: 'confirmation',
    title: 'Appointment Confirmation',
    canActivate: [confirmationGuard],
    loadComponent: () => import('./components/confirmation-page/confirmation-page.component').then(m => m.ConfirmationPageComponent)
  },
  {
    path: 'cancellation',
    title: 'Cancel Appointment',
    loadComponent: () => import('./components/cancellation-page/cancellation-page.component').then(m => m.CancellationPageComponent)
  },
  {
    path: 'cancellation-confirmation',
    title: 'Cancellation Confirmation',
    loadComponent: () =>
      import('./components/cancellation-confirmation-page/cancellation-confirmation-page.component').then(
        m => m.CancellationConfirmationPageComponent
      )
  },
  {
    path: 'cancellation-confirmation-success',
    title: 'Booking Cancellation',
    loadComponent: () =>
      import('./components/cancellation-confirmation-success/cancellation-confirmation-success.component').then(
        m => m.CancellationConfirmationSuccessComponent
      )
  },
  { path: '**', redirectTo: ``, pathMatch: 'full' }
];
